import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";

const PAYMENT_METHODS = [
  "PAYPAL",
  "CREDIT_CARD",
  "VISA",
  "MASTER_CARD",
  "BITCOIN",
];

const generateReference = () => {
  const now = new Date();
  return (
    "AFRO-" +
    now.getFullYear().toString().slice(-2) +
    (now.getMonth() + 1).toString().padStart(2, "0") +
    now.getDate().toString().padStart(2, "0") +
    "-" +
    Math.random().toString(36).substring(2, 8).toUpperCase()
  );
};

const Checkout = () => {
  const { cart } = useCart();
  const { user, isAuthenticated } = useAuth(); // Get user from auth context
  const [reference, setReference] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("PAYPAL");
  const [customerId, setCustomerId] = useState("");
  const [message, setMessage] = useState("");

  const ORDER_API = process.env.REACT_APP_ORDER_SERVICE_URL;

  useEffect(() => {
    setReference(generateReference());
    if (isAuthenticated && user) {
      // If user is an object with `username`
      setCustomerId(user.username ?? user.id ?? "");
    }
  }, [isAuthenticated, user]);

  const getCurrency = () => {
    return cart.length > 0 ? cart[0].currency || "ETB" : "USD";
  };

  const formatPrice = (value, currency) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(value);

  const calculateTotal = () =>
    cart.reduce((acc, item) => acc + item.price * item.quantity, 0);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!customerId) {
      setMessage("❗ Customer ID is required.");
      return;
    }

    const orderRequest = {
      reference,
      totalAmount: calculateTotal(),
      paymentMethod,
      customerId,
      products: cart.map((item) => ({
        productId: item.productId || item.id,
        quantity: item.quantity,
      })),
    };

    try {
      await axios.post(
        ORDER_API + "orders/create",

        orderRequest,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setMessage("✅ Order placed successfully!");
    } catch (error) {
      console.error("Checkout error:", error);
      setMessage("❌ Failed to place order.");
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm p-4 mx-auto" style={{ maxWidth: "600px" }}>
        <h2 className="mb-4 text-center">🧾 Checkout</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="reference" className="form-label">
              Order Reference
            </label>
            <input
              type="text"
              className="form-control"
              id="reference"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="customerId" className="form-label">
              Customer ID
            </label>
            <input
              type="text"
              className="form-control"
              id="customerId"
              placeholder="Enter your Customer ID"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              required
              readOnly={isAuthenticated} // Make readonly if logged in
            />
          </div>

          <div className="mb-3">
            <label htmlFor="paymentMethod" className="form-label">
              Payment Method
            </label>
            <select
              className="form-select"
              id="paymentMethod"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              {PAYMENT_METHODS.map((method) => (
                <option key={method} value={method}>
                  {method.replace("_", " ")}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4 fw-semibold">
            Total:{" "}
            <span className="text-primary">
              {formatPrice(calculateTotal(), getCurrency())}
              {/* {calculateTotal().toFixed(2)} */}
            </span>
          </div>

          <button type="submit" className="btn btn-primary w-100">
            🛍️ Place Order
          </button>

          {message && (
            <div
              className={`alert mt-4 text-center ${
                message.startsWith("✅") ? "alert-success" : "alert-danger"
              }`}
              role="alert"
            >
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Checkout;
